import React from 'react'
import PropTypes from 'prop-types'

export default function LoadingBar({
  id,
  lightMode,
  isNotification = false,
  isIrtis = false,
}) {
  return (
    <div
      id={id}
      className={`loading-border ${isIrtis ? 'collapsed' : 'expanded'} ${
        lightMode && 'light'
      } ${isNotification && 'notification-bar'}`}
      data-testid="notification-loading-bar"
    >
      <span />
    </div>
  )
}

LoadingBar.propTypes = {
  id: PropTypes.string,
  lightMode: PropTypes.bool,
  isNotification: PropTypes.bool,
  isIrtis: PropTypes.bool,
}
